// GA4 custom events. gtag is defined in index.html (Consent Mode v2), so calls are
// safe before consent: GA4 receives a cookieless ping until the visitor opts in.
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (e) {
    // Analytics must never break the page.
  }
}

// One event name for every printable, so Search Console clicks can be compared with
// how many visitors actually print. action: 'print' (browser print / Save as PDF) or
// 'download' (generated PDF file).
export function trackPrintable(puzzle, action, params = {}) {
  trackEvent('printable_download', { puzzle, action, ...params });
}
